import { createApiAction } from '@app/packages/api/utils'
import type { ApiParent } from '@app/packages/api/v2/types/entities'

export const getParentsTrusting = () =>
  createApiAction('getParentsTrusting', dispatch => dispatch<{ data: ApiParent[] }>({ method: 'GET', endpoint: '/api/v2/parents/trusting' }))
